//don't add any newlines between the tick marks, otw you'll get a blank item in the bucket of texts
const sentenceText = `My watch fell in the water.
Breathing is difficult.
I can see the rings on Saturn.
Physics and chemistry are hard.
My bank account is overdrawn.
We are having spaghetti.
Elephants are afraid of mice.
That is my favorite place to visit.
Watch out for low flying objects.
Please provide your date of birth.
We run the risk of failure.
He is just like everyone else.
The world is a stage.
Are you talking to me?
Yes, you are very smart.
The force is with you.
Did you have a good time?
Space is a high priority.
You are a wonderful example.
Do not squander your time.
Do not drink too much.
The music is better than it sounds.
Come and see our new car.
I am going to a music lesson.
Soon we will return from the city.
I am wearing a jacket and a tie.
There will be some fog tonight.
I am allergic to bees and peanuts.
He is still on our team.
My preferred treat is chocolate.
The king sends you to the tower.
We are subjects and must obey.
Mom made her a turtleneck.
We went grocery shopping.
The assignment is due today.
What you see is what you get.
The store will close at ten.
That is very unfortunate.
This is a very good idea.
Our phone number has changed.
Thank you for your help.
The library is closed today.
Mary had a little lamb.
This watch is too expensive.
The postal service is very slow.
Fall is my favorite season.
A fox is a very smart animal.
The kids are very excited.
The parking lot is full of trucks.
My bike has a flat tire.
Do not walk too quickly.
A duck quacks to ask for food.
The sun rises in the east.
It is very windy today.
Do not worry about this.
He was wearing a sweatshirt.
I will meet you at noon.
I want to hold your hand.
The children are playing outside.
Do you like to shop on Sunday?
I spilled coffee on the carpet.
Do not drink the water.
My car always breaks in the winter.
Do you like to go camping?
The protesters blocked all traffic.
The acceptance speech was boring.
Work hard to reach the summit.
A good joke deserves a good laugh.
The union will go on strike.
Never mix religion and politics.
Tickets are very expensive.
A picture is worth many words.
This camera takes nice photographs.
It looks like a shack.
The dog buried the bone.
I just cannot figure this out.
Please follow the guidelines.
An airport is a very busy place.
The bus was very crowded.
It should be sunny tomorrow.
A doctor will help you.
You should visit a dentist.
You must make an appointment.
Players must know all the rules.
Would you like to come to my house?
February has an extra day.
Do not feel too bad about it.
This library has many books.
I like to play tennis.
It is difficult to concentrate.
I listen to the tape everyday.
He is shouting loudly.
The plug does not fit the socket.
We dine out on the weekends.
The water was monitored daily.
He watched in astonishment.
There was a big scratch on the tabletop.
Salesmen must make their monthly quota.
Saving that child was an heroic effort.
Granite is the hardest of all rocks.
We have enough witnesses.
Dolphins leap high out of the water.
The ventilation system is broken.
Dinosaurs have been extinct for ages.
The high waves will swamp us.
The treasurer must balance her books.
They watched the entire movie.`;

export default sentenceText;